import React from "react";
import { HeaderTitle } from "colbi_web_ui/lib/components";

const HeaderTitleWrapper = ({ title }) => {
    return <HeaderTitle overTitle={title[0]}>{title[1]}</HeaderTitle>;
};

export default HeaderTitleWrapper;
